import { render } from "./LocationDetailPage.vue?vue&type=template&id=32627da0&scoped=true"
import script from "./LocationDetailPage.vue?vue&type=script&lang=js"
export * from "./LocationDetailPage.vue?vue&type=script&lang=js"

import "./LocationDetailPage.vue?vue&type=style&index=0&id=32627da0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32627da0"]])

export default __exports__